import {
    RecoleccionActionTypes,
    IRecoleccion,
    SET_RECOLECCION_DESTINO,
    SET_RECOLECCION_ORIGEN
} from "../types/recoleccionActionTypes";
import {Defaults} from "../../defaults/Defaults";

export const initialRecoleccionState: IRecoleccion = {
    paisId: Defaults.Mexico,
    codigoPostal: "",
    direccion: "",
    aceptaCita: false,
    esForanea: false,
    sinAreaServicio: false,
    completado: false
};

export function recoleccionOrigenReducer(state = initialRecoleccionState, action: RecoleccionActionTypes): IRecoleccion {
    switch (action.type) {
        case SET_RECOLECCION_ORIGEN:
            return action.recoleccion;
        default:
            return state;
    }
}

export function recoleccionDestinoReducer(state = initialRecoleccionState, action: RecoleccionActionTypes): IRecoleccion {
    switch (action.type) {
        case SET_RECOLECCION_DESTINO:
            return action.recoleccion;
        default:
            return state;
    }
}

